import React, { Component, PropTypes } from "react";
import axios from "axios";
import {
  EditorState,
  Modifier,
  convertToRaw,
  stateToHTML,
  stateFromHTML,
  ContentState
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import List from "react-virtualized/dist/commonjs/List";
import "react-virtualized/styles.css";

class AddRelatedProducts extends Component {
  state = {
    products: [],
    selectedProducts: [],
    showModal: false,
    isLoading: false,
    failed: false,
    shopName: null,
    storeNameSet: false
  };
  static propTypes = {
    onChange: PropTypes.func,
    editorState: PropTypes.object
  };

  selectProduct = value => e => {
    const isSelected = e.target.checked;
    if (isSelected) {
      let p = [...this.state.selectedProducts, value];
      this.setState({ selectedProducts: p });
    } else {
      const index = this.state.selectedProducts.findIndex(
        i => i.title === value.title
      );
      let p = [...this.state.selectedProducts];
      p.splice(index, 1);
      this.setState({ selectedProducts: p });
    }
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  fetchProducts = () => {
    this.setState({ isLoading: true, failed: false, products: [] });
    axios
      .get(
        `https://lifmr7ro73.execute-api.ap-southeast-2.amazonaws.com/Prod/products?shop=${this
          .state.shopName}`
      )
      .then(response => {
        const products = response.data;
        products.sort((a, b) => (a.title <= b.title ? -1 : 1));

        this.setState({
          products,
          isLoading: false,
          failed: false
        });
      })
      .catch(e => {
        console.error(e);
        this.setState({ products: [], failed: true, isLoading: false });
      });
  };

  addToRelated = () => {
    const { editorState, onChange } = this.props;
    const words = this.state.selectedProducts.reduce(
      (p, c) =>
        `${p}⭐ <a href="https://www.teacherspayteachers.com/${c.url}">${c.title}</a><br>`,
      `<strong>Related Products</strong><br>`
    );
    // EditorState.moveFocusToEnd(this.props.editorState);
    let currentHTML = draftToHtml(
      convertToRaw(this.props.editorState.getCurrentContent())
    );
    currentHTML = currentHTML + `<p>${words}</p>`;
    const { contentBlocks, entityMap } = htmlToDraft(currentHTML);
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    onChange(EditorState.push(editorState, contentState, "insert-fragment"));
    this.setState({ showModal: false, selectedProducts: [] });
  };

  rowRenderer = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    style // Style object to be applied to row (to position it)
  }) => {
    const p = this.state.products[index];
    return (
      <div key={key} style={style}>
        <label
          style={{
            width: 350,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          <input type="checkbox" onChange={this.selectProduct(p)} />
          {p.title}
        </label>
      </div>
    );
  };

  renderModal() {
    return (
      <div>
        <div
          className="modal-background"
          onClick={() => this.setState({ showModal: false })}
        />
        <div
          className="modal"
          style={{
            position: "absolute",
            background: "white",
            padding: 5,
            zIndex: 10
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h3>Add Related Products</h3>
              <div
                className="close-button"
                onClick={() => this.setState({ showModal: false })}
              >
                X
              </div>
            </div>
            <div>
              <input
                type="text"
                placeholder="Your shop name"
                onChange={e => this.setState({ shopName: e.target.value })}
              />
              <button className="btn" onClick={() => this.fetchProducts()}>
                Find Products
              </button>
            </div>
            <hr />
            <div>
              {this.state.isLoading && <div>Loading products...</div>}
              {this.state.failed && (
                <div>
                  Could not find any products for the store. Please ensure you
                  spelled it correctly.
                </div>
              )}
              <List
                width={400}
                height={300}
                rowCount={this.state.products.length}
                rowHeight={25}
                rowRenderer={this.rowRenderer}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={this.addToRelated}>
              Add Product Links
            </button>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>
        {this.state.showModal && this.renderModal()}
        <div className="rdw-option-wrapper" onClick={this.showModal}>
          Add related products
        </div>
      </div>
    );
  }
}

export default AddRelatedProducts;



// WEBPACK FOOTER //
// ./src/AddRelatedProducts.js